import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';

export const PACKAGE_NAME = 'jira.navigation.sidebar.core';

export const MENU_ID = 'project/core';

export const SECTION_ID = {
	ISSUES: 'issues',
	REPORTS: 'reports',
	SETTINGS: 'settings',
	ISSUE_TYPES: 'issuetypes',
} as const;

export const REPORTS_ROUTES_SET = new Set<RouteName>([
	'legacy-all-reports',
	'legacy-reports-configure',
	'legacy-reports-average-age-report',
	'legacy-reports-created-vs-resolved-report',
	'legacy-reports-pie-report',
	'legacy-reports-recently-created-report',
	'legacy-reports-resolution-time-report',
	'legacy-reports-single-level-group-by-report',
	'legacy-reports-time-since-report',
	'legacy-reports-time-tracking-report',
	'legacy-reports-developer-workload-report',
	'legacy-reports-version-workload-report',
	'legacy-reports-workload-pie-report',
]);

export const SETTINGS_ROUTES_SET = new Set<RouteName>([
	'project-settings-core-proforma-project-forms',
	'project-settings-classic-issue-layout',
	'legacy-project-settings-edit',
	'legacy-project-settings-config',
	'project-settings-classic-data-classifications',
	'legacy-project-settings-fields',
	'legacy-project-settings-issue-layout',
	'legacy-project-settings-issue-security',
	'legacy-project-settings-issue-types',
	'legacy-project-settings-notifications',
	'legacy-project-settings-opsgenie',
	'legacy-project-settings-permissions',
	'legacy-project-settings-screens',
	'legacy-project-settings-summary',
	'legacy-project-settings-workflows',
	'legacy-project-settings-collectors',
	'legacy-project-settings-people',
	'project-settings-automation',
	'project-settings-versions',
	'project-settings-components',
	'legacy-project-settings-dev',
]);

export const ISSUES_ROUTES_SET = new Set<RouteName>([
	'legacy-pin',
	'issue-navigator',
	'issue-navigator-core',
]);

export const FORGE_ROUTES_SET = new Set<RouteName>([
	'forge-spa-project',
	'project-settings-core-forge-apps',
]);

export const JIRA_AUTOMATION_ADDON_KEY = 'com.codebarrel.addons.automation';
export const JIRA_FEDRAMP_MODERATE_AUTOMATION_ADDON_KEY =
	'com.codebarrel.addons.automation.moderate';

export const MENU_ITEM_HEIGHT = gridSize * 5;

export const PROJECT_ICON_SIZE = 24;

export const LOCATION = 'jwmNavigationCreateProject';

export const OVERVIEW_MAX_LIMIT = 10;
